/* eslint react/forbid-prop-types:0 */

import React, { Component } from 'react';
import i18n from 'app/common/lib/i18n';
import PropTypes from 'prop-types';
import { Box, Button } from 'gestalt';

const SCROLL_THROTTLE_TIMEOUT = 10;
const SCROLL_MARGIN_OF_ERROR = 66;

export class FormFooter extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      isSticky: true,
    };
  }

  componentDidMount() {
    if (this.props.isStickyFooter) {
      this.scrollResizeHandler = this.onScroll;

      window.addEventListener('scroll', this.scrollResizeHandler);
      window.addEventListener('resize', this.scrollResizeHandler);
    }
  }

  componentWillUnmount() {
    if (this.props.isStickyFooter) {
      clearTimeout(this.scrollingTimer);

      window.removeEventListener('scroll', this.scrollResizeHandler);
      window.removeEventListener('resize', this.scrollResizeHandler);

      this.scrollResizeHandler = null;
    }
  }

  // TODO(imad): create sticky reusable component from the code below
  onScroll = () => {
    clearTimeout(this.scrollingTimer);

    this.scrollingTimer = setTimeout(this.calculateStickyFooter, SCROLL_THROTTLE_TIMEOUT);
  };

  calculateStickyFooter = () => {
    if (!this.props.lastSectionContainer) {
      return;
    }

    const offsetBottom = this.props.lastSectionContainer.getBoundingClientRect().bottom;

    // make footer sticky when the last section element is above the current scroll position
    if (offsetBottom + SCROLL_MARGIN_OF_ERROR > window.innerHeight) {
      this.setState({
        isSticky: true,
      });
    } else {
      this.setState({
        isSticky: false,
      });
    }
  };

  render() {
    const { confirmText, onCancel, onConfirm } = this.props;

    const style = {};

    if (this.props.isStickyFooter && this.state.isSticky) {
      style.position = 'fixed';
    }

    return (
      <div className="formFooter" style={style}>
        {this.props.children}
        <div className="formFooterButtons">
          {onCancel && (
            <Box marginRight={2} display="inlineBlock">
              <Button
                inline
                onClick={onCancel}
                text={i18n._('Cancel', 'Cancel action to dismiss modal')}
              />
            </Box>
          )}
          <Button inline onClick={onConfirm} text={confirmText} color="red" />
        </div>
      </div>
    );
  }
}

FormFooter.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]),
  confirmText: PropTypes.string.isRequired,
  isStickyFooter: PropTypes.bool.isRequired,
  lastSectionContainer: PropTypes.any,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func.isRequired,
};

export default FormFooter;
